import { UserPlus, Grid, Settings } from 'react-feather';

const pagesSection = [
  {
    href: 'produkter',
    title: 'Produkter',
    icon: Grid,
    children: [
      {
        href: '/partner/sites',
        title: 'Landningssidor',
      },
      {
        href: '/partner/hemsidor',
        title: 'Hemsidor',
      },
    ],
  },
  {
    href: 'leads',
    title: 'Kundförfrågningar',
    icon: UserPlus,
  },
  {
    href: 'settings',
    title: 'Inställningar',
    icon: Settings,
  },
];

const navItems = [
  {
    title: '',
    pages: pagesSection,
  },
];

export default navItems;
